/**
 * دانلودِ عکسِ برنامه در مرورگر (WHOSUP-213).
 *
 * ═══ چرا `<a href={url} download>` کافی نیست ═══
 *
 * آدرسِ عکس **امضاشده و از دامنه‌ی سوپابیس** است، یعنی cross-origin. صفتِ
 * `download` در آن حالت نادیده گرفته می‌شود: مرورگر به‌جای ذخیره، عکس را
 * در تبِ تازه باز می‌کند و نامِ فایل هم هرچه در آدرس بود می‌ماند. پس
 * بایت‌ها را خودمان می‌گیریم و از روی یک `blob:` محلی ذخیره می‌کنیم —
 * آن‌جا هم‌ریشه است و `download` کار می‌کند.
 */
import { photoFileName } from '@/core/lib/signalPhotos';
import { reportError } from '@/core/lib/report';
import type { SignalPhoto } from '@/core/domain/types';

async function saveOne(photo: SignalPhoto): Promise<boolean> {
  if (!photo.url) return false;
  const res = await fetch(photo.url);
  if (!res.ok) throw new Error(`fetch ${res.status}`);
  const blob = await res.blob();

  const href = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = href;
  a.download = photoFileName(photo.path);
  // بعضی مرورگرها لینکی را که به سند وصل نیست کلیک‌نشدنی می‌دانند.
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  a.remove();
  // آزاد کردنِ فوری، دانلودِ همین لحظه را در بعضی مرورگرها قطع می‌کند.
  setTimeout(() => URL.revokeObjectURL(href), 60_000);
  return true;
}

/**
 * یک یا چند عکس. ورودی همیشه آرایه است، حتی برای یکی — همان قرارِ
 * `savePhotos` در موبایل، تا نام‌گذاری و رفتار دو جور پیاده نشود.
 *
 * **پشتِ سر هم و نه موازی.** چند `fetch` هم‌زمانِ چندمگابایتی هیچ چیزی را
 * زودتر نمی‌کند، و کروم دانلودِ پشتِ‌سرهم را یک‌بار می‌پرسد («اجازه‌ی
 * دانلودِ چند فایل؟») به‌جای اینکه هر کدام را جدا ببیند.
 *
 * شکستِ یکی بقیه را نمی‌خواباند — همان قاعده‌ی `uploadPhotos`.
 */
export async function downloadPhotos(
  photos: SignalPhoto[],
): Promise<{ ok: number; failed: number }> {
  let ok = 0;
  let failed = 0;
  for (const p of photos) {
    try {
      if (await saveOne(p)) ok += 1; else failed += 1;
    } catch (e) {
      reportError('web.photoDownload', e, { path: p.path });
      failed += 1;
    }
  }
  return { ok, failed };
}
